<template lang="pug">
Modal#modalSentDesktop(idName='modalSentDesktop')
  template(v-slot:modal-header='')
    button.btn-close(
      type='button',
      data-bs-dismiss='modal',
      aria-label='Close'
    )
  template(v-slot:modal-body='')
    h2
      | Para emitir um novo Certificado Digital
      | através de Token ou Cartão, você; vai precisar
      | acessar esta página pelo computador ou notebook.
    img(src='@/assets/images/sent-desktop.svg', alt='menina sorrindo')
  template(v-slot:modal-footer='')
    button.btn.btn-primary(
      type='button',
      data-bs-dismiss='modal',
      aria-label='Close'
    )
      span.me-2 Fechar
      Icon(name='x')
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import Icon from '@/components/Atoms/Icon.vue'
  import Modal from '@/components/Molecules/Modal.vue'

  export default defineComponent({
    components: {
      Icon,
      Modal,
    },
  })
</script>
